var React = require('react');

function Notification (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15 17H9C9 18.6569 10.3431 20 12 20C13.6569 20 15 18.6569 15 17Z","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M18.8803 17H4.98718C4.16558 17 3.70136 16.0694 4.21308 15.4266C4.5883 14.9553 4.99447 14.4592 5.38308 14.0098C5.89974 13.4123 6.20855 12.6573 6.22155 11.8675C6.28211 8.18915 6.87321 3 12.6432 3C17.1184 3 18.0239 8.59364 17.9012 11.7851C17.8689 12.6262 18.091 13.4699 18.6263 14.1195L19.652 15.364C20.1896 16.0163 19.7256 17 18.8803 17Z","stroke":"currentColor","strokeWidth":"1.5","key":1})]);
}

Notification.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Notification;

Notification.default = Notification;
